import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';

import { AddPropertyFormComponent, type PropertyFormData } from './add-property-form.component';
import { PropertyQuestionnaireComponent } from './property-questionnaire.component';

@Component({
  selector: 'app-add-property-flow',
  imports: [AddPropertyFormComponent, PropertyQuestionnaireComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @switch (step()) {
      @case ('form') {
        <app-add-property-form
          (save)="handleSaveProperty($event)"
          (back)="cancelled.emit()"
        />
      }
      @case ('questionnaire') {
        <app-property-questionnaire
          [propertyData]="propertyData()"
          (completed)="completed.emit()"
        />
      }
    }
  `,
})
export class AddPropertyFlowComponent {
  readonly completed = output<void>();
  readonly cancelled = output<void>();

  protected readonly step = signal<'form' | 'questionnaire'>('form');
  protected readonly propertyData = signal<PropertyFormData | null>(null);

  protected handleSaveProperty(data: PropertyFormData): void {
    this.propertyData.set(data);
    this.step.set('questionnaire');
  }
}
